import { useFilterProviderTypeContext } from "./filter-provider-type.context";

export function FilterProviderType() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterProviderTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}